import { render } from "./tw-grid-view.vue?vue&type=template&id=230d1f78"
import script from "./tw-grid-view.vue?vue&type=script&lang=js"
export * from "./tw-grid-view.vue?vue&type=script&lang=js"
script.render = render

export default script